import { useEffect } from 'react';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';

const VillaAguaPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleReserveClick = () => {
    window.REACT_APP_NAVIGATE('/');
    setTimeout(() => {
      const reserveSection = document.getElementById('reserve');
      if (reserveSection) {
        reserveSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  };

  const images = [
    {
      url: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/60de74325b464a5fa93913cc1e7d241a.jpeg',
      alt: 'Villa Agua - Beautiful white villa with arched doorways'
    },
    {
      url: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/0603b144fa6a24768b62ff4d39970dbc.jpeg',
      alt: 'Villa Agua interior bedroom with elegant decor'
    },
    {
      url: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/f0d1bd625f14abb014f6f34cb1a8900f.jpeg',
      alt: 'Villa Agua serene bedroom with natural light'
    },
    {
      url: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/5cfbd67123f7d7f98cf76ab4425fec9e.jpeg',
      alt: 'Villa Agua peaceful bedroom with twin beds'
    },
    {
      url: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/a539363f2797a6061c76c9042ec35348.jpeg',
      alt: 'Villa Agua bright bedroom with colorful wall art'
    },
    {
      url: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/18b6814bc0fda576bb4c8a54e2768c74.jpeg',
      alt: 'Villa Agua cozy bedroom with warm lighting'
    }
  ];

  return (
    <div className="min-h-screen">
      <Navigation />
      
      <main className="pt-20">
        {/* Hero Section */}
        <section className="relative h-[60vh] min-h-[500px]">
          <img
            src={images[0].url}
            alt={images[0].alt}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/30 to-transparent"></div>
          <div className="absolute inset-0 flex items-end">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16 w-full">
              <h1 className="text-5xl md:text-6xl font-serif font-bold text-white mb-4">
                Villa Agua
              </h1>
              <p className="text-xl text-white/90 max-w-2xl">
                Flow and fluidity define this serene space. Calming blue accents 
                and water features create a peaceful atmosphere.
              </p>
            </div>
          </div>
        </section>

        {/* Overview Section */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
              <div className="lg:col-span-2">
                <h2 className="text-3xl font-serif font-bold text-gray-900 mb-6">
                  About Villa Agua
                </h2>
                <div className="prose prose-lg text-gray-600 space-y-4">
                  <p>
                    Villa Agua embodies the flowing, adaptive nature of water. This serene 
                    sanctuary features calming blue accents, water features, and design elements 
                    that create a sense of peace and emotional balance.
                  </p>
                  <p>
                    The villa's design celebrates fluidity and grace, with gentle curves, soothing 
                    colors, and thoughtful details that invite you to flow with life rather than 
                    resist it. Every space has been created to support emotional healing and 
                    inner peace.
                  </p>
                  <p>
                    Perfect for those seeking emotional balance, intuitive connection, and deep 
                    relaxation, Villa Agua offers a tranquil retreat where you can reconnect 
                    with your inner flow.
                  </p>
                </div>
              </div>

              <div className="bg-sand-50 rounded-2xl p-8">
                <h3 className="text-2xl font-serif font-bold text-gray-900 mb-6">
                  Villa Details
                </h3>
                <div className="space-y-4">
                  <div className="flex items-start">
                    <i className="ri-user-line text-2xl text-primary-500 mr-3 mt-1"></i>
                    <div>
                      <div className="font-semibold text-gray-900">Capacity</div>
                      <div className="text-gray-600">Sleeps 2-3 guests</div>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-hotel-bed-line text-2xl text-primary-500 mr-3 mt-1"></i>
                    <div>
                      <div className="font-semibold text-gray-900">Bedrooms</div>
                      <div className="text-gray-600">2 bedrooms</div>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-shower-line text-2xl text-primary-500 mr-3 mt-1"></i>
                    <div>
                      <div className="font-semibold text-gray-900">Bathrooms</div>
                      <div className="text-gray-600">1 full bathroom</div>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-water-flash-line text-2xl text-primary-500 mr-3 mt-1"></i>
                    <div>
                      <div className="font-semibold text-gray-900">Special Features</div>
                      <div className="text-gray-600">Water features and calming blue accents</div>
                    </div>
                  </div>
                </div>

                <button
                  onClick={handleReserveClick}
                  className="w-full mt-8 bg-primary-500 hover:bg-primary-600 text-white px-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
                >
                  Reserve Villa Agua
                </button>
              </div>
            </div>
          </div>
        </section>

        {/* Photo Gallery */}
        <section className="py-16 bg-sand-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-serif font-bold text-gray-900 mb-12 text-center">
              Photo Gallery
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {images.map((image, index) => (
                <div 
                  key={index}
                  className="relative h-80 rounded-2xl overflow-hidden shadow-lg group cursor-pointer"
                >
                  <img
                    src={image.url}
                    alt={image.alt}
                    className="w-full h-full object-cover object-top transition-transform duration-300 group-hover:scale-110"
                  />
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Amenities Section */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-serif font-bold text-gray-900 mb-12 text-center">
              Amenities
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-wifi-line text-4xl text-primary-500"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">High-Speed WiFi</h3>
                <p className="text-sm text-gray-600">Stay connected throughout your stay</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-temp-cold-line text-4xl text-primary-500"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Air Conditioning</h3>
                <p className="text-sm text-gray-600">Climate control in all rooms</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-restaurant-line text-4xl text-primary-500"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Full Kitchen</h3>
                <p className="text-sm text-gray-600">Fully equipped for meal preparation</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-parking-box-line text-4xl text-primary-500"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Free Parking</h3>
                <p className="text-sm text-gray-600">Complimentary on-site parking</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-service-line text-4xl text-primary-500"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Daily Housekeeping</h3>
                <p className="text-sm text-gray-600">Keep your space fresh and clean</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-cake-2-line text-4xl text-primary-500"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Organic Breakfast</h3>
                <p className="text-sm text-gray-600">Healthy breakfast included daily</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-water-flash-line text-4xl text-primary-500"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Water Features</h3>
                <p className="text-sm text-gray-600">Calming water elements throughout</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-yoga-line text-4xl text-primary-500"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Yoga Space Access</h3>
                <p className="text-sm text-gray-600">Shared yoga and meditation areas</p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-gradient-to-br from-primary-50 to-sand-50">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-4xl font-serif font-bold text-gray-900 mb-6">
              Ready to Experience Villa Agua?
            </h2>
            <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
              Limited spots available for our upcoming retreats. Reserve your place in this 
              tranquil sanctuary and begin your journey of emotional balance and inner peace.
            </p>
            <button
              onClick={handleReserveClick}
              className="bg-primary-500 hover:bg-primary-600 text-white px-12 py-4 rounded-lg text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer inline-block"
            >
              Reserve Your Spot
            </button>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default VillaAguaPage;